import { jsx, jsxs } from "react/jsx-runtime";
import { ChatBubble } from "@pcln/horizon";
import { motion } from "motion/react";
import { Box, ChatMessage, Flex, Spinner, Text } from "pcln-design-system";
import { useContext, useEffect, useState } from "react";
import { ChatMessage as index_js_ChatMessage } from "./components/CustomChatMessage/index.js";
import { HotelLoadingSkeletonComponent } from "./components/Loading/HotelLoadingSkeletonComponent.js";
import { CustomMarkdown } from "./components/MarkdownComponent/CustomMarkdown.js";
import TryAgain from "./components/TryAgain/index.js";
import { ChatbotDataContext } from "./context/ChatbotDataContext.js";
import { useLoadingStateContext } from "./hooks/useLoadingStateContext.js";
import { ScrollIntoView } from "./ScrollIntoView.js";
import { StyledLoadingBox } from "./StyledLoadingBubble.js";
import { TravelBotLogoImage } from "./TravelBotLogoImage.js";
const DialogLoading = (props)=>{
    const [showTryAgain, setShowTryAgain] = useState(false);
    const hasContentInStreamingText = props.streamingText?.trim() && props.streamingText?.replaceAll('\n', '');
    const showEllipsis = !hasContentInStreamingText;
    const ellipsisProps = {
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        bg: '#868d95'
    };
    const { loadingHotelSkeleton } = useLoadingStateContext();
    const { setiValues } = useContext(ChatbotDataContext);
    const TIMEOUT = props.timeout || 120000;
    const MessageIcon = function() {
        return /*#__PURE__*/ jsx(TravelBotLogoImage, {});
    };
    useEffect(()=>{
        const timeoutId = setTimeout(()=>{
            setShowTryAgain(true);
        }, TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, []);
    useEffect(()=>{
        if (!showEllipsis) setShowTryAgain(false);
    }, [
        showEllipsis
    ]);
    const hasLoadingStatusMessages = Array.isArray(props?.loadingStatusMessages) && props?.loadingStatusMessages?.length > 0;
    const lastStatus = props.loadingStatusMessages?.[props.loadingStatusMessages?.length - 1];
    const spinnerMessage = /*#__PURE__*/ jsxs(Flex, {
        alignItems: 'center',
        pl: '4px',
        children: [
            /*#__PURE__*/ jsx(Box, {
                width: 24,
                height: 24,
                children: /*#__PURE__*/ jsx(Spinner, {
                    size: 24
                })
            }),
            /*#__PURE__*/ jsx(Text, {
                fontSize: 2,
                ml: 2,
                children: lastStatus
            })
        ]
    });
    const streamingMessage = /*#__PURE__*/ jsxs(Box, {
        children: [
            hasContentInStreamingText && /*#__PURE__*/ jsx(CustomMarkdown, {
                children: props.streamingText
            }),
            showEllipsis && /*#__PURE__*/ jsx(motion.div, {
                children: /*#__PURE__*/ jsxs(StyledLoadingBox, {
                    mt: 1,
                    width: "62px",
                    height: "32px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_1"
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_2"
                        }),
                        /*#__PURE__*/ jsx(Box, {
                            ...ellipsisProps,
                            id: "ellipses_3"
                        })
                    ]
                })
            })
        ]
    });
    const getChatBubble = (content)=>/*#__PURE__*/ jsx(ChatBubble, {
            role: "response",
            showResponseIcon: true,
            children: content
        });
    const getStreamingChatMessage = (content)=>{
        if (showEllipsis) return /*#__PURE__*/ jsx(ChatMessage, {
            mb: 40,
            Icon: MessageIcon,
            variation: "initial",
            message: content
        });
        if (hasContentInStreamingText) return /*#__PURE__*/ jsx(index_js_ChatMessage, {
            mb: 40,
            Icon: MessageIcon,
            variation: "initial",
            message: content
        });
    };
    return showTryAgain ? /*#__PURE__*/ jsx(ScrollIntoView, {
        children: /*#__PURE__*/ jsx(TryAgain, {
            lastMessage: `DialogLoading - Component (timeout set to ${TIMEOUT}):: ${props?.lastMessage || 'unknown lastMessage'}`
        })
    }) : /*#__PURE__*/ jsxs("div", {
        className: props.isMobile ? '' : 'mb-10',
        children: [
            hasLoadingStatusMessages && !hasContentInStreamingText && (setiValues?.shouldEnablePortalUpdates ? getChatBubble(spinnerMessage) : /*#__PURE__*/ jsx(index_js_ChatMessage, {
                mb: 40,
                Icon: MessageIcon,
                variation: "initial",
                message: spinnerMessage
            })),
            loadingHotelSkeleton && /*#__PURE__*/ jsx(HotelLoadingSkeletonComponent, {
                isMobile: props.isMobile
            }),
            (hasContentInStreamingText || !hasLoadingStatusMessages && showEllipsis) && (setiValues?.shouldEnablePortalUpdates ? getChatBubble(streamingMessage) : getStreamingChatMessage(streamingMessage))
        ]
    });
};
export { DialogLoading };
